import Vue from 'vue'
import Vuex from 'vuex'
import { secondsToFullTimestamp, secondsToFormatDateInput, toSlug } from '@/Helper.js' 
import { numeración_de_documentos, coleccion_salidas, customAuth, numeracion_de_documentos, coleccion_salidas_emitir_guia, coleccion_salidas_emitir_comprobante, salesCollection } from '../../FirebaseConfig';

Vue.use(Vuex)
export default {
    namespaced:true,
        state: {
            data:{
              items: [],
              warehouse: [],
              numero_de_bultos: 0,
              peso_bruto_total: 0,
            },
            loading: true,
            registro:[],
            cantidad_de_registros: 0,
            selectedKey:'',
            registerDialog: false,
            searchingDate: [],
            annulDialog: false,
            paso_de_formulario: 1,
            massiveDialog: false,
        },
   
        actions: {
          
            obtener_todo:({state}, event)=>{
              state.loading = true
              const {itemsPerPage, page} = event
              let ref = coleccion_salidas

              if(state.cantidad_de_registros > 0 ) ref = ref.where('numero_de_operacion', '<=', state.cantidad_de_registros - itemsPerPage * (page-1) )
              
              ref.limit(itemsPerPage).orderBy('numero_de_operacion', 'desc').onSnapshot(collection=>{
                const colección = []
                collection.docs.map( item => colección.push({ ...item.data(), id: item.id }) )
                state.registro = colección
                state.loading = false
              })
              numeración_de_documentos.collection('Nota de salida').doc('00').onSnapshot( doc=> state.cantidad_de_registros = doc.exists ? doc.data().numeracion : 0 )
            },
            
            lookingForDates:({state})=>{
              state.loading = true,
              coleccion_salidas
              .where('creado_el', '>', new Date(state.searchingDate[0]))
              .where('creado_el', '<', new Date(state.searchingDate[1]))
              .onSnapshot(collection=>{
                const colección = []
                collection.docs.map( item => colección.push({ ...item.data(), id: item.id }) )
                state.registro = colección
                state.loading = false
              })
              //numeración_de_documentos.collection('Nota de salida').doc('00').onSnapshot(doc=>state.cantidad_de_registros = doc.exists ? doc.data().numeracion : 0)

            },
            add: async({state, dispatch, commit})=>{
                state.loading = true
                return new Promise (async (resolve, rejected)=> {
                  try {
                    if(state.selectedKey==''){
                      
                      let numeracion = await numeracion_de_documentos.collection('Nota de salida').doc('00').get()
                      let nueva_numeracion = (!numeracion.exists) ? 1 : numeracion.data().numeracion + 1
                      
                      let datos_a_grabar = {
                        ...state.data,
                        enviar_automaticamente_a_la_sunat: true,
                        enviar_automaticamente_al_cliente: true,
                        creado_el: new Date, 
                        creado_por: customAuth.currentUser.displayName,
                        documento_de_operacion: 'Nota de salida',
                        serie_guia: 'T001',
                        nombre_de_documento_guia: 'Guía de remisión',
                        tipo_de_documento_guia: 7,
                        numero_de_operacion: nueva_numeracion,
                        warehouse: state.data.warehouse,
                        estado_del_documento: 'esperando',
                        guias: [],
                      }
                      datos_a_grabar.items.map(item => delete item.existence)
                      await coleccion_salidas.add(datos_a_grabar)
                      await numeracion_de_documentos.collection('Nota de salida').doc('00').set({numeracion: nueva_numeracion})
                      state.loading = false
                      commit('Helpers/launchSnackbar', 'Se ha registrado la nota de salida', { root: true })
                      state.registerDialog = false
                      resolve(nueva_numeracion)
                    
                      let { total_gravada, proveedor_denominacion, condiciones_de_pago, motivo_de_traslado, numero_de_operacion } = datos_a_grabar
                      if(motivo_de_traslado == '01') dispatch('Movimientos_contables/movimiento_contable', {valor: total_gravada, regla:"Venta", proveedor_denominacion, fecha_caducidad: condiciones_de_pago, referencia: `Nota de Salida Nº ${numero_de_operacion}`, fecha: new Date}, { root: true }) 
                        
                  } else {
                      await coleccion_salidas.doc(state.data.key).update({
                        ...state.data, 
                        actualizado_el: new Date(), 
                      })
                      state.loading = false
                      state.registerDialog = false
                      commit('Helpers/launchSnackbar', 'Se ha actualizado la operación', { root: true })
                      resolve(true)

                    }     
                  } catch( error ) { 
                    state.loading = false
                    state.registerDialog = false
                    Object.keys(state.data).map(item => {
                      if (state.data[item] == undefined)  commit('Helpers/launchSnackbar', `Ocurrió un error en el campo ${item}`, { root: true })
                    })
                    console.log(error)
                    rejected('Error')
                  }

                })
            },
            annul:(context,key)=>{
                coleccion_salidas.doc(key).update({isAnnulled: true, annulledAt: new Date}).then(()=>{
                    context.commit('Helpers/launchSnackbar', 'Se ha anulado el documento', { root: true })
                    context.state.annulDialog = false
                    context.state.registerDialog = false
                })
            },
            massiveAdd: async ({state, dispatch, commit}, data) => {
                state.selectedKey=''
                const lista_de_almacenes = []
                data.map(item => {
                  if(lista_de_almacenes.indexOf(item.almacen) == -1) lista_de_almacenes.push(item.almacen)
                })
                
                let warehouseItem = {}
                for await ( const almacen of lista_de_almacenes) {
                  let dataToProcess = data.filter( item => item.almacen == almacen)
                  warehouseItem[almacen] = []
                  for await ( const item of dataToProcess) {
                    let elemento = await dispatch('Product/getKeyByCode', item.codigo,  { root: true })
                    warehouseItem[almacen].push( {...elemento,  cantidad: Number(item.cantidad), precio_unitario: 0, tipo_de_igv: 1} )
                  }
                }

                let mainWarehouse = await dispatch('Warehouse/getMainWarehouse', '', { root: true })
                
                let arrWarehouse = Object.keys(lista_de_almacenes).map(item=>lista_de_almacenes[item])
                    
                for await (const thisWarehose of arrWarehouse){
                    state.data = {
                        items: warehouseItem[thisWarehose.trim()],
                        cliente_denominacion: thisWarehose,
                        cliente_direccion: '',
                        cliente_email: '',
                        cliente_numero_de_documento: '',
                        cliente_tipo_de_documento: '',
                        creado_el: new Date(), 
                        descuento_global: '',
                        estado_del_documento: 'esperando',
                        creado_por: customAuth.currentUser.displayName,
                        fecha_de_emision: secondsToFormatDateInput(new Date()),
                        guias: [],
                        documento_de_operacion: "Nota de salida",
                        serie_guia: '0',
                        tipo_de_documento_guia: 7,
                        total: 0, 
                        total_descuento: 0,
                        total_exonerado: 0,
                        total_gravado: 0,
                        total_igv: 0,
                        motivo_de_traslado: '4',
                        nombre_motivo_de_traslado: 'TRANSSFERENCIA ENTRE ALMACENES',
                        nombre_de_documento_guia: 'Guía de remisión',
                        warehouse: [
                          {
                            name: mainWarehouse[0].name,
                            slug: mainWarehouse[0].slug
                          },
                          {   
                            name: thisWarehose.trim(),
                            slug: toSlug(thisWarehose.trim())
                          },
                        ],
                    }
                    await dispatch('add')
                    commit('Helpers/launchSnackbar', `Se ha registrado la operación del almacén ${thisWarehose}`, { root: true })
                }
                state.massiveDialog = false
            },
            get:(context, key)=>{
                coleccion_salidas.doc(key).get().then(doc=>{
                    context.state.data = {
                        ...doc.data(), 
                        key: key, 
                        createdAt: secondsToFullTimestamp(doc.data().createdAt),
                        date: secondsToFormatDateInput(doc.data().date),
                        annulledAt: secondsToFullTimestamp(doc.data().annulledAt),
                    }
                    context.state.selectedKey = key
                })
            },
            generar_facturacion:async(context,key)=>{
                let datos = await coleccion_salidas.doc(key).get()
                salesCollection.add({
                    ...datos.data(),
                    nombre_de_comprobante:'',
                    serie:'',
                    tipo_de_comprobante:'',
                    warehouse: context.state.data.warehouse,
                    estado_del_documento: 'esperando'
                }).then(()=>{
                    context.commit('Helpers/launchSnackbar', 'Se ha generado una venta', { root: true })
                })
            },
            closeDocument:(context, key)=>coleccion_salidas.doc(key).update({isClose: true}),
            clearForm: context => {
              context.state.data = {
                items: [],
                moneda: 1,
                warehouse: [],
                numero_de_bultos: 0,
                peso_bruto_total: 0,
                fecha_de_emision: new Date().toISOString().substr(0, 10),
                fecha_de_inicio_de_traslado: new Date().toISOString().substr(0, 10),
              }
              context.state.paso_de_formulario = 1
              context.state.selectedKey = ''
            },
            abrir_documentos: async ({state, commit}) => {

              const registro = await coleccion_salidas.get()
              registro.docs.map( item => coleccion_salidas.doc(item.id).update( { estado_del_documento: 'esperando' } )
                  .then(()=>commit('Helpers/launchSnackbar', 'Se ha abierto todos los documentos', { root: true }) ) 
                  .catch(error=>commit('Helpers/launchSnackbar', error, { root: true }) ) 
              )

            },
            reverse: (context) => {
                context.rootState.Inputs.data = {...context.state.data, supplier: context.state.data.client }
                context.dispatch( 'Inputs/add', '', {root: true} )
                if(context.state.data.warehouse[1]) {
                    context.state.data.warehouse[0] = context.state.data.warehouse[1]
                    context.dispatch('add')
                }
            },
            emitir_guia: (context, key) => {
                coleccion_salidas.doc(key).update({estado_del_documento: 'procesando'})
                coleccion_salidas_emitir_guia.add({key: key, creado_por: customAuth.currentUser.displayName})
            },
            
            emitir_comprobante: ({dispatch}, key) => {
              dispatch('add').then(val => {
                  coleccion_salidas.doc(key).update({estado_del_documento: 'procesando'})
                  coleccion_salidas_emitir_comprobante.add({key: key})
                }
              )
            },
            regresar_procesado: (context, key) => {
                coleccion_salidas.doc(key).update({estado_del_documento: 'esperando'})
            }
        },
        getters: {
          registro: state => state.registro.map(item => {
              
              let comprobante_serie_numero = (item.serie_comprobante && item.numero_comprobante) ? `${String(item.serie_comprobante).padStart(4, 0)}-${String(item.numero_comprobante).padStart(5, 0)}` : '' 
              let comprobante_reversion_serie_numero = (item.serie_comprobante_reversion && item.numero_comprobante_reversion) ? `${String(item.serie_comprobante_reversion).padStart(4, 0)}-${String(item.numero_comprobante_reversion).padStart(5, 0)}` : '' 
              let guia_serie_numero = (item.serie_guia && item.numero_guia) ? `${String(item.serie_guia).padStart(4, 0)}-${String(item.numero_guia).padStart(5, 0)} ` : '' 
            
              return({
                ...item, 
                almacén_de_origen: item.warehouse && item.warehouse[0] ? item.warehouse[0].name : '',
                almacén_de_destino: item.warehouse && item.warehouse[1] ? item.warehouse[1].name : '',
                comprobante_serie_numero,
                guia_serie_numero,
                comprobante_reversion_serie_numero
              })
            })
          
        }
}



